import { Component, type PropsWithChildren } from 'react';

type State = { error: Error | null };

export class ErrorBoundary extends Component<PropsWithChildren, State> {
  override state: State = { error: null };
  static getDerivedStateFromError(error: Error): State { return { error }; }
  override componentDidCatch(error: Error): void { console.error('[app] error boundary caught:', error); }
  override render() {
    if (this.state.error) {
      return (
        <div className="h-full grid place-items-center p-6 text-neutral-200">
          <div className="max-w-md space-y-3 text-center">
            <h2 className="text-lg font-semibold">Something broke.</h2>
            <p className="text-sm text-neutral-400">{this.state.error.message}</p>
            <button
              type="button"
              onClick={() => location.reload()}
              className="inline-flex rounded-md bg-white text-neutral-950 px-3 py-1.5 text-sm font-medium"
            >
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
